import { AromaBannerVariant } from "@zenchef/styled-system/recipes";
import { IconProps } from "../Icon/Icon";

export const getIcons = (
  theme: AromaBannerVariant["colorTheme"],
): IconProps["name"] | null => {
  switch (theme) {
    case "neutral":
      return "placeholder-circle";
    case "info":
      return "info-circle";
    case "success":
      return "check-01-circle";
    case "warning":
      return "alert-circle";
    case "error":
      return "alert-triangle";
    default:
      return null;
  }
};

export const getTheme = (
  form: AromaBannerVariant["form"],
  colorTheme: AromaBannerVariant["colorTheme"],
): [boolean, boolean, boolean] => {
  const isBar = form === "bar";
  const isOat = colorTheme === "oat";
  const isBlue = colorTheme === "blue";

  return [isBar, isOat, isBlue];
};
